import { Col, Row } from 'reactstrap';
import { clx, formatLocalAddress } from 'Utils';
import { useModal } from 'Hooks';
import { BusinessPartnerMe, Logo, Media } from 'Types';
import {
	LoadingSpinner,
	ModalBoxChangeImage,
	EditButton,
	FontAwesome
} from 'Elements';
import styles from 'partials/homepage/section/profile-hero-header.module.scss';

type Props = {
	isLoadingProfile: boolean;
	businessPartnerMe: BusinessPartnerMe;
	initialState: {
		headerTitle: string;
		description: string;
		slogan: string;
	};
	isFetchingProfile: boolean;
	onChangeValue: (
		objKey: string,
		key: string,
		value: string | boolean | Logo
	) => void;
	header: {
		description: string;
		headerImage: Logo;
		headerTitle: string;
		logo: Logo;
		slogan: string;
		themeColor: number;
	};
};

export const BusinessPartnerHeroHeader = ({
	isLoadingProfile,
	businessPartnerMe,
	onChangeValue,
	initialState,
	isFetchingProfile,
	header
}: Props) => {
	const defaultLogo = '/assets/img/business-partner-default.png';
	const [openModal, toggleModal] = useModal();

	const handleUploadImage = async (image_data: Media) => {
		if (image_data) {
			onChangeValue('header', 'logo', {
				url: image_data?.absoluteUri,
				thumbnail: image_data?.thumbnailUrl
			} as Logo);
		}
	};

	const handleResetLogo = async () => {
		onChangeValue('header', 'logo', {
			url: '',
			thumbnail: ''
		} as Logo);
	};
	return (
		<div style={{ marginTop: '-5rem' }}>
			{isLoadingProfile && (
				<div className="d-flex align-items-center justify-content-center">
					<LoadingSpinner />
				</div>
			)}
			{!isLoadingProfile && header && (
				<div className="ps-lg-4">
					<Row className="g-0 mb-4 ps-xxl-4">
						<Col lg={3} xxl={2}>
							<div
								className={styles.headerLogo}
								role="button"
								onClick={toggleModal}>
								<img
									src={
										(header?.logo?.url as string) ||
										defaultLogo
									}
									alt={header?.headerTitle}
									className={styles.logo}
								/>
								<div className="edit-overlay">
									<EditButton className="edit-overlay-icon" />
								</div>
								{isFetchingProfile && (
									<span className={styles.overlay}>
										<LoadingSpinner
											size="xl"
											color="#fff"
										/>
									</span>
								)}
							</div>
						</Col>
						<Col lg={9} xxl={10} className="ps-xxl-4">
							<div className="d-flex flex-column gap-2 justify-content-end h-100 pt-lg-5">
								<h3
									className={clx(
										styles.title,
										'fw-700 mb-0 text-break mt-5 pt-xl-3'
									)}>
									<input
										type="text"
										onChange={(e) =>
											onChangeValue(
												'header',
												'headerTitle',
												e.target.value
											)
										}
										value={header?.headerTitle ?? ''}
										id="headerTitle"
										placeholder={initialState?.headerTitle}
										className={`${styles.inputEdit} w-90`}
									/>
								</h3>
								{businessPartnerMe?.slogan && (
									<div className="d-flex align-items-center gap-2">
										<div className="fs-base text-gray-3 lh-md text-break">
											{businessPartnerMe?.slogan}
										</div>
										<div
											onClick={() => {
												window.open(
													'/my-business-partner/general'
												);
											}}>
											<FontAwesome
												icon="pen-to-square"
												size="lg"
												className="text-primary cursor-pointer"
											/>
										</div>
									</div>
								)}

								{businessPartnerMe?.address && (
									<div className="d-flex align-items-center gap-2 text-gray-3 fs-sm lh-base position-relative w-100">
										<div>
											<FontAwesome
												icon="location-dot"
												size="1x"
												className="me-1"
											/>
											{formatLocalAddress(
												businessPartnerMe?.address
													?.street,
												businessPartnerMe?.address
													?.houseNumber,
												businessPartnerMe?.address
													?.postalCode,
												businessPartnerMe?.address
													?.city,
												businessPartnerMe?.address
													?.state
											)}
										</div>
										<div
											onClick={() => {
												window.open(
													'/my-business-partner/address'
												);
											}}>
											<FontAwesome
												icon="pen-to-square"
												size="lg"
												className="text-primary cursor-pointer"
											/>
										</div>
									</div>
								)}
							</div>
						</Col>
					</Row>
					{businessPartnerMe?.description && (
						<Row className="justify-content-end g-0 ps-xxl-4">
							<Col
								lg={9}
								xxl={10}
								className="ps-xxl-4 d-flex align-items-center gap-2">
								<div
									className="fs-base text-gray-3 lh-md text-break"
									style={{ whiteSpace: 'pre-wrap' }}
									dangerouslySetInnerHTML={{
										__html: businessPartnerMe?.description
									}}></div>
								<div
									onClick={() => {
										window.open(
											'/my-business-partner/general'
										);
									}}>
									<FontAwesome
										icon="pen-to-square"
										size="lg"
										className="text-primary cursor-pointer"
									/>
								</div>
							</Col>
						</Row>
					)}
				</div>
			)}
			<ModalBoxChangeImage
				name="logo"
				isOpen={openModal}
				title="title.change-logo"
				image={(header?.logo?.url as string) || ''}
				defaultImage="/assets/img/business-partner-default.png"
				onClose={toggleModal}
				onRemove={handleResetLogo}
				onImageChange={handleUploadImage}
			/>
		</div>
	);
};
